import { __extends, __decorate } from 'tslib';
import { Component, Vue } from 'vue-property-decorator';

/**
 * Тело таблицы (`tbody`)
 */
var HseTableBody = /** @class */ (function (_super) {
    __extends(HseTableBody, _super);
    function HseTableBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HseTableBody = __decorate([
        Component({
            name: 'HseTableBody'
        })
    ], HseTableBody);
    return HseTableBody;
}(Vue));

export default HseTableBody;
